export default {
  en: {
    // Migrated from <i18n> SFC blocks (#6500)
    'voice-voice-report-warning': 'Voice data is only available after it has been saved in SMG. Click',
    driveThru: 'Drive-Thru',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'McDelivery Analysis',
    kiosk: 'Kiosk',
    // ServiceTimeStats
    'highlighted-rows': '* Highlighted rows have 1 or more bad quarter hours that have been masked and WILL NOT be included in any calculations due to bad data received from the POS',
    'premium-upgrade-message-start': 'Organizations that reward shifts for hitting OEPE targets have seen a 20 second improvement.',
    'premium-upgrade-message-link-text': 'Upgrade to Premium',
    'premium-upgrade-message-end': ' to get started with Rewards.',
    'service-time-stats': 'Service Time Statistics',
    'DT': 'DT',
    'FC': 'FC',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Bev',
    'service-time-stats-analysis': 'Service Time Stats Analysis',
    // MOPServiceTimes
    'mop-service-times': 'MOP Service Times',
    'grid-footer': '* Ready On Arrival(ROA) orders that were sent to the POS while customer was traveling to the restaurant.',
    'curbside': 'Curbside',
    'table-side': 'Table Side',
    'int-delivery': 'Integrated McDelivery',
    // voice
    'voice-report-warning': 'To set up the email import for VOICE Comments, please follow the instructions',
    'here': 'here',
    // dtTimer
    'dt-timer': 'DT Timer',
    // YYNN
    'YY': 'Y / Y',
    'YN': 'Y / N',
    'NY': 'N / Y',
    'NN': 'N / N',
    'YY_DESC': 'OEPE Down, Guest Counts Up',
    'YN_DESC': 'OEPE Down, Guest Counts Down',
    'NY_DESC': 'OEPE Up, Guest Counts Up',
    'NN_DESC': 'OEPE Up, Guest Counts Down',
    // MatrixGrid
    'matrix-grid-name': 'Drive Thru YY NN Matrix',
    'weekly-trend': 'Weekly Trend',
    // DifferenceGrid
    'weekly-yot': 'Weekly YoY DT Performance',
    'current': 'Current',
    'previous': 'Previous',
    // YYNNChart
    'DT-trend': 'Drive Thru YY/NN Trend',
    // CustomerFeedback
    'customer-feedback': 'Customer Feedback',
    // SpeedOfService
    'speed-of-service': 'Speed of Service',
    'drive-thru': 'Drive-Thru',
    'front-counter': 'Front Counter',
    'table-service': 'Table Service',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Beverage',
  },
  es: {
    // Migrated from <i18n> SFC blocks (#6500)
    'voice-voice-report-warning': 'Los datos de voz solo están disponibles después de haber sido guardados en SMG. Haga clic',
    driveThru: 'Autoservicio',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'Análisis de McDelivery',
    kiosk: 'Quiosco',
    // ServiceTimeStats
    'highlighted-rows': '* Las filas resaltadas tienen 1 o más cuartos de hora incorrectos que se han enmascarado y NO se incluirán en ningún cálculo debido a los datos incorrectos recibidos del POS.',
    'premium-upgrade-message-start': 'Las organizaciones que recompensan los turnos por alcanzar los objetivos de OEPE han visto una mejora de 20 segundos.',
    'premium-upgrade-message-link-text': 'Actualiza a Premium',
    'premium-upgrade-message-end': ' para comenzar con Recompensas.',
    'service-time-stats': 'Estadísticas de Tiempo de Servicio',
    'DT': 'DT',
    'FC': 'FC',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Bev',
    'service-time-stats-analysis': 'Análisis de Estadísticas de Tiempo de Servicio',
    // MOPServiceTimes
    'mop-service-times': 'Tiempos de Servicio MOP',
    'grid-footer': '* Las órdenes Ready On Arrival (ROA) que se enviaron al POS mientras el cliente viajaba al restaurante.',
    'curbside': 'Servicio en la Acera',
    'table-side': 'Lado de la Mesa',
    'int-delivery': 'McDelivery Integrado',
    // voice
    'voice-report-warning': 'Para configurar la importación de correo electrónico para los comentarios de VOICE, siga las instrucciones',
    'here': 'aquí',
    // dtTimer
    'dt-timer': 'Minutero DT',
    // YYNN
    'YY': 'Y / Y',
    'YN': 'Y / N',
    'NY': 'N / Y',
    'NN': 'N / N',
    'YY_DESC': 'OEPE a la baja, conteo de clientes al alza',
    'YN_DESC': 'OEPE a la baja, conteo de clientes a la baja',
    'NY_DESC': 'OEPE al alza, conteo de clientes al alza',
    'NN_DESC': 'OEPE al alza, conteo de clientes a la baja',
    // MatrixGrid
    'matrix-grid-name': 'Matriz YY NN de Drive Thru',
    'weekly-trend': 'Tendencia Semanal',
    // DifferenceGrid
    'weekly-yot': 'Rendimiento semanal DT interanual',
    'current': 'Actual',
    'previous': 'Anterior',
    // YYNNChart
    'DT-trend': 'Tendencia DT YY/NN',
    // CustomerFeedback
    'customer-feedback': 'Comentarios del Cliente',
    // SpeedOfService
    'speed-of-service': 'Velocidad de Servicio',
    'drive-thru': 'Autoservicio',
    'front-counter': 'Mostrador',
    'table-service': 'Servicio en Mesa',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Bebidas',
  },
  fr: {
    // Migrated from <i18n> SFC blocks (#6500)
    'voice-voice-report-warning': 'Les données Voice ne sont disponibles qu’après leur enregistrement dans SMG. Cliquez',
    driveThru: 'Drive',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'Analyse McDelivery',
    kiosk: 'Borne',
    // ServiceTimeStats
    'highlighted-rows': '* Les lignes surlignées comportent un ou plusieurs quarts d’heure erronés qui ont été masqués et NE SERONT PAS inclus dans les calculs, en raison de données incorrectes reçues du système de caisse',
    'premium-upgrade-message-start': 'Les organisations qui récompensent les postes atteignant les objectifs OEPE ont constaté une amélioration de 20 secondes.',
    'premium-upgrade-message-link-text': 'Passez à Premium',
    'premium-upgrade-message-end': ' pour commencer à utiliser les Récompenses.',
    'service-time-stats': 'Statistiques des temps de service',
    'DT': 'DT',
    'FC': 'FC',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Bois.',
    'service-time-stats-analysis': 'Analyse des statistiques des temps de service',
    // MOPServiceTimes
    'mop-service-times': 'Temps de service MOP',
    'grid-footer': '* Commandes Ready On Arrival (ROA) envoyées au système de caisse pendant que le client se rendait au restaurant.',
    'curbside': 'Retrait en voiture',
    'table-side': 'Livraison à table',
    'int-delivery': 'McDelivery intégré',
    // voice
    'voice-report-warning': 'Pour configurer l’import des commentaires VOICE par e-mail, veuillez suivre les instructions',
    'here': 'ici',
    // dtTimer
    'dt-timer': 'Chrono Drive',
    // YYNN
    'YY': 'O / O',
    'YN': 'O / N',
    'NY': 'N / O',
    'NN': 'N / N',
    'YY_DESC': 'OEPE en baisse, nombre de clients en hausse',
    'YN_DESC': 'OEPE en baisse, nombre de clients en baisse',
    'NY_DESC': 'OEPE en hausse, nombre de clients en hausse',
    'NN_DESC': 'OEPE en hausse, nombre de clients en baisse',
    // MatrixGrid
    'matrix-grid-name': 'Matrice YY NN du Drive',
    'weekly-trend': 'Tendance hebdomadaire',
    // DifferenceGrid
    'weekly-yot': 'Performance hebdomadaire du Drive en glissement annuel',
    'current': 'Actuel',
    'previous': 'Précédent',
    // YYNNChart
    'DT-trend': 'Tendance YY/NN du Drive',
    // CustomerFeedback
    'customer-feedback': 'Retours clients',
    // SpeedOfService
    'speed-of-service': 'Vitesse de service',
    'drive-thru': 'Drive',
    'front-counter': 'Comptoir',
    'table-service': 'Service à table',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Boissons',
  },
  'fr-ca': {
    // Migrated from <i18n> SFC blocks (#6500)
    'voice-voice-report-warning': 'Les données Voice ne sont disponibles qu’après leur enregistrement dans SMG. Cliquez',
    driveThru: 'Service au volant',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'Analyse McDelivery',
    kiosk: 'Borne',
    // ServiceTimeStats
    'highlighted-rows': '* Les rangées surlignées comportent un ou plusieurs quarts d’heure erronés qui ont été masqués et NE SERONT PAS inclus dans les calculs, en raison de données erronées reçues du PDV',
    'premium-upgrade-message-start': 'Les organisations qui récompensent les quarts atteignant les cibles OEPE ont constaté une amélioration de 20 secondes.',
    'premium-upgrade-message-link-text': 'Passez à Premium',
    'premium-upgrade-message-end': ' pour commencer à utiliser les Récompenses.',
    'service-time-stats': 'Statistiques des temps de service',
    'DT': 'SV',
    'FC': 'CO',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Breuv.',
    'service-time-stats-analysis': 'Analyse des statistiques des temps de service',
    // MOPServiceTimes
    'mop-service-times': 'Temps de service MOP',
    'grid-footer': '* Commandes Ready On Arrival (ROA) transmises au PDV pendant que le client se rendait au restaurant.',
    'curbside': 'Ramassage en bordure de rue',
    'table-side': 'Livraison à la table',
    'int-delivery': 'McDelivery intégré',
    // voice
    'voice-report-warning': 'Pour configurer l’importation par courriel des commentaires VOICE, veuillez suivre les instructions',
    'here': 'ici',
    // dtTimer
    'dt-timer': 'Minuterie du service au volant',
    // YYNN
    'YY': 'O / O',
    'YN': 'O / N',
    'NY': 'N / O',
    'NN': 'N / N',
    'YY_DESC': 'OEPE en baisse, achalandage en hausse',
    'YN_DESC': 'OEPE en baisse, achalandage en baisse',
    'NY_DESC': 'OEPE en hausse, achalandage en hausse',
    'NN_DESC': 'OEPE en hausse, achalandage en baisse',
    // MatrixGrid
    'matrix-grid-name': 'Matrice YY NN du service au volant',
    'weekly-trend': 'Tendance hebdomadaire',
    // DifferenceGrid
    'weekly-yot': 'Rendement hebdomadaire du service au volant d’une année à l’autre',
    'current': 'Actuel',
    'previous': 'Précédent',
    // YYNNChart
    'DT-trend': 'Tendance YY/NN du service au volant',
    // CustomerFeedback
    'customer-feedback': 'Commentaires des clients',
    // SpeedOfService
    'speed-of-service': 'Rapidité du service',
    'drive-thru': 'Service au volant',
    'front-counter': 'Comptoir',
    'table-service': 'Service à la table',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Breuvages',
  },
};
